import React from 'react';

interface PencilOutlineIconProps {
  size?: number;
  color?: string;
}

const PencilOutlineIcon: React.FC<PencilOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.9015 18.2304L5.92114 18.5753L6.26611 14.595L14.5452 6.36892C14.6689 6.24255 14.8164 6.14214 14.9793 6.07359C15.1421 6.00503 15.3171 5.96973 15.4939 5.96973C15.6706 5.96973 15.8456 6.00503 16.0085 6.07359C16.1715 6.14214 16.319 6.24255 16.4425 6.36892L18.1275 8.0672C18.2519 8.19055 18.3506 8.3373 18.418 8.49898C18.4854 8.66066 18.52 8.83407 18.52 9.00922C18.52 9.18437 18.4854 9.35779 18.418 9.51948C18.3506 9.68116 18.2519 9.8279 18.1275 9.95124L9.9015 18.2304Z" stroke={color} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.82943 5.98483C1.36382 5.90382 1.36382 5.23542 1.82943 5.15442C3.51626 4.86095 4.85787 3.57615 5.22401 1.9036L5.25208 1.77539C5.35281 1.31522 6.00804 1.31235 6.11279 1.77163L6.14686 1.92104C6.52655 3.5857 7.86854 4.85965 9.55068 5.1523C10.0187 5.23371 10.0187 5.90553 9.55068 5.98694C7.86854 6.27959 6.52655 7.55354 6.14686 9.21821L6.11279 9.36762C6.00804 9.8269 5.35281 9.82403 5.25208 9.36385L5.22401 9.23566C4.85787 7.5631 3.51626 6.27829 1.82943 5.98483Z" stroke={color} strokeWidth="1.425" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default PencilOutlineIcon;
